var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIfpbLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ifpb-logo",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    x: "35%",
    y: "25%",
    width: "50%",
    height: "50%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "actor_1",
    cx: "10%",
    cy: "10%",
    r: "9.25%",
    opacity: 1,
    fill: "rgba(200,25,30,1)",
    fillOpacity: 1,
    stroke: "rgba(166,3,17,1)",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "actor_2",
    x: "22.5%",
    y: "0%",
    rx: 2,
    ry: 2,
    width: "20%",
    height: "20%",
    opacity: 1,
    fill: "rgba(50,160,65,1)",
    fillOpacity: 1,
    stroke: "",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "actor_3",
    x: "45%",
    y: "0%",
    rx: 2,
    ry: 2,
    width: "20%",
    height: "20%",
    opacity: 1,
    fill: "rgba(50,160,65,1)",
    fillOpacity: 1,
    stroke: "",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "actor_4",
    x: "0%",
    y: "22.5%",
    rx: 2,
    ry: 2,
    width: "20%",
    height: "20%",
    opacity: 1,
    fill: "rgba(50,160,65,1)",
    fillOpacity: 1,
    stroke: "",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "actor_5",
    x: "22.5%",
    y: "22.5%",
    rx: 2,
    ry: 2,
    width: "20%",
    height: "20%",
    opacity: 1,
    fill: "rgba(50,160,65,1)",
    fillOpacity: 1,
    stroke: "",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "actor_6",
    x: "0%",
    y: "45%",
    rx: 2,
    ry: 2,
    width: "20%",
    height: "20%",
    opacity: 1,
    fill: "rgba(50,160,65,1)",
    fillOpacity: 1,
    stroke: "",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "actor_7",
    x: "22.5%",
    y: "45%",
    rx: 2,
    ry: 2,
    width: "20%",
    height: "20%",
    opacity: 1,
    fill: "rgba(50,160,65,1)",
    fillOpacity: 1,
    stroke: "",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "actor_8",
    x: "45%",
    y: "45%",
    rx: 2,
    ry: 2,
    width: "20%",
    height: "20%",
    opacity: 1,
    fill: "rgba(50,160,65,1)",
    fillOpacity: 1,
    stroke: "",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "actor_9",
    x: "0%",
    y: "67.5%",
    rx: 2,
    ry: 2,
    width: "20%",
    height: "20%",
    opacity: 1,
    fill: "rgba(50,160,65,1)",
    fillOpacity: 1,
    stroke: "",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "actor_10",
    x: "22.5%",
    y: "67.5%",
    rx: 2,
    ry: 2,
    width: "20%",
    height: "20%",
    opacity: 1,
    fill: "rgba(50,160,65,1)",
    fillOpacity: 1,
    stroke: "",
    strokeWidth: 0,
    strokeOpacity: 1,
    strokeDasharray: ""
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "40%",
    cy: "30%",
    r: 0,
    fill: "none",
    stroke: "rgba(200,25,30,1)",
    strokeWidth: ""
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;20",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline",
    begin: "0s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "40%",
    cy: "30%",
    r: 0,
    fill: "none",
    stroke: "#32a041",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;20",
    keyTimes: "0;1",
    keySplines: "0 0.2 0.8 1",
    calcMode: "spline",
    begin: "-0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0.2 0 0.8 1",
    calcMode: "spline",
    begin: "-0.5s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfpbLoading);
export default __webpack_public_path__ + "static/media/ifpb-loading.049716af4361f3bee1a0d82e3109890c.svg";
export { ForwardRef as ReactComponent };